import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { AuthProvider, ROLES } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Contacts from './pages/Contacts';
import Opportunities from './pages/Opportunities';
import OpportunityDetail from './pages/OpportunityDetail';
import Targets from './pages/Targets';
import Outreach from './pages/Outreach';
import AccessControl from './pages/AccessControl';
import Users from './pages/Users';
import Organizations from './pages/Organizations';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
};

// Superadmin (Role 99) Only
const SuperadminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(localStorage.getItem('sv_user') || '{}');
    const roleId = Number(user.RoleID);
    if (roleId !== ROLES.SUPERADMIN) return <Navigate to="/dashboard" replace />;
  } catch (e) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

// Superadmin (99) or Org Admin (98)
const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(localStorage.getItem('sv_user') || '{}');
    const roleId = Number(user.RoleID);
    if (roleId !== ROLES.SUPERADMIN && roleId !== ROLES.ORG_ADMIN) {
      return <Navigate to="/dashboard" replace />;
    }
  } catch (e) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/dashboard" replace /> : children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
      <Route path="/outreach" element={<ProtectedRoute><Outreach /></ProtectedRoute>} />
      <Route path="/lead-approaching" element={<ProtectedRoute><Outreach /></ProtectedRoute>} />
      <Route path="/approaching" element={<ProtectedRoute><Outreach /></ProtectedRoute>} />
      <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
      <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
      <Route path="/opportunities/:id" element={<ProtectedRoute><OpportunityDetail /></ProtectedRoute>} />
      <Route path="/targets" element={<ProtectedRoute><Targets /></ProtectedRoute>} />
      <Route path="/organizations" element={<SuperadminRoute><Organizations /></SuperadminRoute>} />
      <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
      <Route path="/access-control" element={<AdminRoute><AccessControl /></AdminRoute>} />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
